import { AnimatePresence, motion } from 'framer-motion'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { Icons } from '@/components/icons'

interface ProviderLoaderProps {
    isLoading: boolean
    title?: string
    message?: string
}

export const ProviderLoader: React.FC<ProviderLoaderProps> = ({
    isLoading,
    title,
    message
}) => {
    const { t } = useTranslation()

    useEffect(() => {
        if (isLoading) {
            document.body.style.overflow = 'hidden'
        } else {
            document.body.style.overflow = 'unset'
        }

        return (): void => {
            document.body.style.overflow = 'unset'
        }
    }, [isLoading])

    return (
        <AnimatePresence>
            {isLoading && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    className="fixed inset-0 z-[9999] flex items-center justify-center backdrop-blur-md bg-white/30 dark:bg-black/30"
                    onClick={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                    }}
                    onMouseDown={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                    }}
                    onTouchStart={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                    }}
                >
                    <div className="bg-white/80 dark:bg-gray-800/80 p-8 rounded-lg shadow-xl text-center max-w-md w-full mx-4 bg-content1">
                        <motion.div
                            animate={{ rotate: 360 }}
                            transition={{
                                duration: 1,
                                repeat: Infinity,
                                ease: 'linear'
                            }}
                            className="inline-block mb-6"
                        >
                            <Icons.Spinner className="text-primary text-6xl" />
                        </motion.div>
                        <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
                            {title || t('loading')}
                        </h2>
                        <p className="text-gray-600 dark:text-gray-300 text-lg">
                            {message || t('pleaseWait')}
                        </p>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    )
}
